import jwtDecode from "jwt-decode";

export const getToken = () => localStorage.getItem("token");

export const getDecodedToken = () => {
    const token = getToken();
    if (!token) return null;

    try {
        return jwtDecode(token);
    } catch (error) {
        return null;
    }
};

export const getCurrentUserRole = () => getDecodedToken()?.role || null;

export const isTokenValid = () => {
    const decoded = getDecodedToken();
    if (!decoded?.exp) return false;

    return decoded.exp > Date.now() / 1000;
};

export const isAdmin = () => getCurrentUserRole() === "ADMIN";

export const isWorker = () => getCurrentUserRole() === "WORKER";
